import * as React from "react";

import "./MatrixSpacer.scss";
import MatrixVariableLabel from "./MatrixVariableLabel";

export default class MatrixSpacer extends React.Component<any> {
  render() {
    const item = this.props.item;
    const rightLabel = item.right ? (
      <MatrixVariableLabel
        variable={item.right}
        side="right"
        delegate={this.props.delegate}
        x={this.props.x}
        y={this.props.y}
        showMenu={this.props.showMenu}
        setShowMenu={this.props.setShowMenu}
        canEdit={this.props.canEdit}
      />
    ) : null;
    const bottomLabel = item.bottom ? (
      <MatrixVariableLabel
        variable={item.bottom}
        side="bottom"
        delegate={this.props.delegate}
        x={this.props.x}
        y={this.props.y}
        showMenu={this.props.showMenu}
        setShowMenu={this.props.setShowMenu}
        canEdit={this.props.canEdit}
      />
    ) : null;
    return (
      <div className="MatrixSpacer">
        {rightLabel}
        {bottomLabel}
      </div>
    );
  }
}
